import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "analytics_session_id";

function getSessionId() {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        (crypto?.randomUUID && crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

/**
 * Auto-fires a page-view to the backend whenever the URL changes.
 * Skips fully on admin/writer/auth routes — only public news traffic is tracked.
 */
export default function useAnalytics(projectId) {
  const location = useLocation();
  const last = useRef("");

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (last.current === path) return;
    last.current = path;
    if (
      path.startsWith("/admin") ||
      path.startsWith("/writer") ||
      path.startsWith("/auth") ||
      path.startsWith("/become-writer")
    ) {
      return;
    }
    const payload = {
      project_id: projectId || null,
      path,
      referrer: document.referrer || null,
      session_id: getSessionId(),
      screen_width: window.innerWidth || null,
      screen_height: window.innerHeight || null,
    };
    // Fire-and-forget — never block render
    axios.post(`${API}/public/analytics/event`, payload).catch(() => {});
  }, [location.pathname, location.search, projectId]);
}
